<template>
  <transition name="image-preview-fade-scale">
    <div class="image-preview-fixed-box" @mousemove="onDraging" @mouseup="onDragEnd"
         v-show="visible">
      <transition name="image-preview-fade">
        <div class="cover-model"
             v-show="modelVisible"></div>
      </transition>
      <div class="image-preview-box">
        <div class="image-preview-header"
             @click.self="modelClick">
             <Icon type="close-round" class="close" @click="closeModal"></Icon>

          <!-- <div class="el-icon-close close"
               @click="closeModal"></div> -->
        </div>
        <div class="image-preview-body"
             @click.self="modelClick">
          <div class="image-preview-picture-box"
               ref="imgBox"
               @click.self="modelClick">
            <img ref="previewImg"
                 :style="[imageStyle]"
                 @wheel.prevent="onZoom"
                 @mousedown="onDragStart"
                 :src="src"
                 v-if="isShowImg && src"
                 @load="loadImage"
                 alt="">
                 
                 <!-- @mousemove="onDraging"
                 @mouseup="onDragEnd" -->
          </div>
          <div class="el-icon-arrow-left prev"
               v-if="isShowPrev"
               @click="prevPic"></div>
          <div class="el-icon-arrow-right next"
               v-if="isShowNext"
               @click="nextPic"></div>
          <div class="image-preview-toolbar">
            <!-- <Icon type="ios-refresh-empty"></Icon><ion-icon name="refresh-outline"></ion-icon>-->
            <Icon type="ios-plus-outline" class="toolbar-item" @click="zoomBig" title="放大"></Icon>
            <Icon type="ios-minus-outline" class="toolbar-item" @click="zoomSmall" title="缩小"></Icon>
            <Icon type="android-refresh" class="toolbar-item" @click="onRotate(1)" title="向左旋转"></Icon>
            <Icon type="android-refresh" class="toolbar-item" style="transform:rotateY(-180deg);" @click="onRotate(-1)" title="向右旋转"></Icon>
            <Icon type="arrow-swap" class="toolbar-item" @click="onMirrorY" title="水平镜像"></Icon>
            <Icon type="arrow-swap" class="toolbar-item" style="transform:rotate(90deg);" @click="onMirrorX" title="垂直镜像"></Icon>
            <!-- <i class="el-icon-zoom-in toolbar-item"
               @click="zoomBig"
               title="放大"></i> -->
            <!-- <i class="el-icon-zoom-out toolbar-item"
               @click="zoomSmall"
               title="缩小"></i> -->
            <!-- <i class="el-icon-refresh toolbar-item"
               style="transform:rotateY(-180deg);"
               @click="onRotate(1)"
               title="向左旋转"></i> -->
            <!-- <i class="el-icon-refresh toolbar-item"
               @click="onRotate(-1)"
               title="向右旋转"></i> -->
            <!-- <i class="el-icon-sort toolbar-item"
               style="transform:rotate(90deg);"
               @click="onMirrorY"
               title="水平镜像"></i>
            <i class="el-icon-sort toolbar-item"
               @click="onMirrorX"
               title="垂直镜像"></i> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "imagePreview",
  mounted(){
    /* 这段代码禁用drag事件 组织印象mouseup事件的触发 */
    // document.ondragstart = function(ev) {
    //     ev.preventDefault();
    // };
    // document.ondragend = function(ev) {
    //     ev.preventDefault();
    // };

    // document.addEventListener('mousemove', this.onDraging)
    // document.addEventListener('mouseup', this.onDragEnd)
  },
  beforeDestroy(){
    
  },
  // beforeDestory(){
  //   document.removeEventListener('mousemove', this.onDraging)
  //   document.removeEventListener('mouseup', this.onDragEnd)
  // },
  computed: {
    // 是否显示上一张
    isShowPrev() {
      let index = this.list.indexOf(this.src);
      if (index == 0 && !this.loop) {
        return false;
      }
      return true;
    },
    // 是否显示下一张
    isShowNext() {
      let index = this.list.indexOf(this.src);
      if (index == this.list.length - 1 && !this.loop) {
        return false;
      }
      return true;
    },
    // 当前图片旋转度数
    // rotateDeg() {
    //   let previewImg = this.$refs.previewImg;
    //   let reg = /(?<=rotateZ\()[^)]*(?=deg\))/;
    //   let rotateDeg = previewImg.style.transform
    //     ? reg.exec(previewImg.style.transform)[0] * 1
    //     : 0; //图片旋转度数
    //   return rotateDeg;
    // },
    // mirrorXDeg(){
    //   let previewImg = this.$refs.previewImg;
    //   let reg = /(?<=rotateY\()[^)]*(?=deg\))/;
    //   let rotateDeg = previewImg.style.transform
    //     ? reg.exec(previewImg.style.transform)[0] * 1
    //     : 0; //图片旋转度数
    // }
    imageStyle() {
        // console.log(this.imageInfo.translateX)
      return {
        // zoom: this.imageInfo.zoomPercent + '%',
        // width: this.imageInfo.width + "px",
        // height: this.imageInfo.height + "px",
        // translate(-50%,-50%)
        left: `${this.imageInfo.translateX * 2}px`,
        top: `${this.imageInfo.translateY * 2}px`,
        transform: `rotateX(${this.imageInfo.mirrorXDeg}deg) rotateY(${
          this.imageInfo.mirrorYDeg
        }deg) rotateZ(${this.imageInfo.rotateDeg}deg) scale(${this.imageInfo.scale})`
        //  translate(${this.imageInfo.translateX}px,${this.imageInfo.translateY}px
      };
    }
  },

  methods: {
    dragStart(ev){
      ev.preventDefault();
    },
    dragEnd(ev){
      ev.preventDefault();
    },
    loadImage(e){
      let previewImg = this.$refs.previewImg
      this.imageInfo.loaded = true
      this.imageInfo.width = previewImg.width
      this.imageInfo.height = previewImg.height
    },
    // 渲染信息
    renderInfo(src) {
      this.src = src;
      this.list = list;
    },
    modelClick() {
      this.$emit("model-click");
      this.closeModal();
    },
    // 关闭预览窗口
    closeModal() {
      this.visible = false;
      if (typeof this.onClose === "function") {
        setTimeout(() => {
          this.onClose(this);
        }, 500);
      }
    },
    prevPic() {
      this.togglePic(-1);
    },
    nextPic() {
      this.togglePic(1);
    },
    onDragStart(e){
      e.preventDefault()
      
      var box = this.$refs.imgBox
      var e = e || window.event;//要用event这个对象来获取鼠标的位置
      var x = e.pageX//e.clientX - box.offsetLeft;
      var y = e.pageY//e.clientY - box.offsetTop;
      this.dragInfo = {
        x: x,
        y: y
      }
      this.draging = true
    },
    onDraging(e){
      if(this.draging && this.dragEnabled){
        var box = this.$refs.imgBox
        var x = e.pageX//e.clientX - box.offsetLeft;
        var y = e.pageY//e.clientY - box.offsetTop;
        this.$nextTick(()=>{
          this.dragEnabled = false
          let translateX = x - this.dragInfo.x,translateY = y - this.dragInfo.y
          this.imageInfo.translateX += translateX
          this.imageInfo.translateY += translateY
          this.dragInfo = {
            x: x,
            y: y
          }
        })
        setTimeout(()=>{
          this.dragEnabled = true
        },10)
      }
    },
    onDragEnd(){
      this.draging = false
    },
    // 切换图片 1 为下一张 -1 为上一张
    togglePic(v) {
      if (this.list.length <= 0) return;
      let index = this.list.indexOf(this.src);
      let src = "";
      if (index !== -1) {
        let newIndex = index + v;
        if (v < 0) {
          // 向上翻页时，如果页面不存在跳转到最后一页
          let lastIndex = this.list.length - 1;
          src = this.list[newIndex]
            ? this.list[newIndex]
            : this.list[lastIndex];
        } else if (v > 0) {
          src = this.list[newIndex] ? this.list[newIndex] : this.list[0];
        }
      } else {
        src = this.list[0];
      }
      this.refreshImage(src);
    },
    refreshImage(src) {
      this.isShowImg = false;
      this.imageInfo = {
        // zoomPercent: 100,
        loaded: false,
        width: "auto",
        height: "auto",
        scale: 1, // 缩放
        rotateDeg: 0,
        mirrorXDeg: 0,
        mirrorYDeg: 0,

        translateX: 0,
        translateY: 0
      };
      this.$nextTick(() => {
        this.src = src;
        this.isShowImg = true;
      });
    },
    // 图片缩放
    onZoom(event) {
      if(!this.zoomEnabled) return
      this.zoomEnabled = false
      if (event.wheelDelta > 0 || event.deltaY < 0) {
        // 放大
        this.zoomBig();
      } else {
        // 缩小
        this.zoomSmall();
      }
      setTimeout(()=>{
        this.zoomEnabled = true
      },30)
    },
    zoomBig() {
       if(this.imageInfo.scale >= 10){
        this.imageInfo.scale = 10  * 1000 / 1000
      } else{
        this.imageInfo.scale = ((this.imageInfo.scale * 1000) + (0.1  * 1000)) / 1000 // 精度问题
      }
    },
    zoomSmall() {
      if(this.imageInfo.scale <= 0.1){
        this.imageInfo.scale = 0.1 * 1000 / 1000
      } else{
        this.imageInfo.scale = ((this.imageInfo.scale * 1000) - (0.1  * 1000)) / 1000 // 精度问题
      }
    },
    // 旋转图片
    onRotate(type) {
      let rotateDeg = this.imageInfo.rotateDeg;
      if (type == 1) {
        rotateDeg += 90;
      } else {
        rotateDeg -= 90;
      }
      this.imageInfo.rotateDeg = rotateDeg;
    },
    // 水平镜像翻转
    onMirrorX(type) {
      let mirrorXDeg = this.imageInfo.mirrorXDeg;
      if (mirrorXDeg % 360 == 0) {
        mirrorXDeg = 180;
      } else {
        mirrorXDeg = 0;
      }
      this.imageInfo.mirrorXDeg = mirrorXDeg;
    },
    // 垂直镜像翻转
    onMirrorY() {
      let mirrorYDeg = this.imageInfo.mirrorYDeg;
      if (mirrorYDeg % 360 == 0) {
        mirrorYDeg = 180;
      } else {
        mirrorYDeg = 0;
      }
      this.imageInfo.mirrorYDeg = mirrorYDeg;
    }
  },
  watch: {
    visible(v, ov) {
      if (v) {
        // setTimeout(() => {
        this.modelVisible = true;
        // }, 500);
      }
    }
  },
  data() {
    return {
      visible: false,
      modelVisible: false, // 是否显示modal
      isShowImg: true, // 是否显示图片，用作刷新状态
      src: "", // 当前显示的图片
      list: [], // 图片列表
      onClose: null,
      loop: false, // 是否循环
      zoomStick: 10, // 缩放像素数，每次滚动缩放多少
      imageInfo: {
        
        loaded: false,
        width: "auto",
        height: "auto",
        scale: 1,
        // zoomPercent: 100,
        rotateDeg: 0,
        mirrorXDeg: 0,
        mirrorYDeg: 0,

        translateX: 0,
        translateY: 0
      },
      zoomEnabled: true, // 节流
      draging: false, // 是否拖动状态
      dragEnabled: true, // 节流
      dragInfo:{
        x: 0,
        y: 0
      }
    };
  }
};
</script>
<style lang="scss">
.image-preview-fade-scale-enter-active,
.image-preview-fade-scale-leave-active {
  transition: all 0.5s;
}
.image-preview-fade-scale-enter, .image-preview-fade-scale-leave-to /* .fade-scale-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scale(0);
}
.image-preview-fade-enter-active,
.image-preview-fade-leave-active {
  transition: all 0.5s;
}
.image-preview-fade-enter, .image-preview-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.image-preview-fixed-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .cover-model {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .image-preview-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .image-preview-header {
      color: #fff;
      width: 100%;
      height: 80px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      .close {
        font-size: 40px;
        position: absolute;
        right: 30px;
        top: 30px;
        cursor: pointer;
        &:hover {
          color: #ccc;
        }
      }
    }
    .image-preview-body {
      width: 100%;
      height: 100%; //calc(100% - 160px);
      position: relative;
      padding: 80px;
      box-sizing: border-box;
      // margin: 100px;
      // box-sizing: border-box;
      .image-preview-picture-box {
        position: relative;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          max-width: 100%;
          max-height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          // transform: translate(-50%, -50%);
          transition: transform 0.4s ease-in-out;
          cursor: grab;
          &:active{
            cursor: grabbing;
          }
        }
      }
      .prev,
      .next {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #fff;
        font-weight: bold;
        font-size: 40px;
        cursor: pointer;
        &:hover {
          color: #ccc;
        }
      }
      .prev {
        left: 10px;
      }
      .next {
        right: 10px;
      }
      .image-preview-toolbar {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        background-color: rgba(187, 187, 187, 0.5);
        border-radius: 5px;
        font-size: 16px;
        display: flex;
        .toolbar-item {
          padding: 5px;
          cursor: pointer;
              width: 26px;
          height: 26px;
          display: flex;
          justify-content: center;
          &:hover {
            background-color: #aaa;
          }
          &:first-of-type:hover {
            border-radius: 5px 0 0 5px;
          }
          &:last-of-type:hover {
            border-radius: 5px 5px 0px 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/imagePreview/main.vue